// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IJZQ","colBig":"styles_colBig__2kGQt","colSmall":"styles_colSmall__DI-Uh"};